import { useCookies } from 'react-cookie';
import Constants from '../../utils/Constants';

const useClubPersistentStorage = () => {
  const [cookies, setCookie] = useCookies([Constants.CLUB_STORAGE_NAME]);

  const getDefaultCookieObject = () => {
    return {
      orgUnitId: '',
      uIProjectName: Constants.UI_PROJECT_NAMES.CLUB,
      returnUrl: '/',
      backToSystemLabel: 'Back to Club Search'
    };
  };

  const setPersistentStorage = (orgUnitId, uIProjectName, returnUrl, backToSystemLabel) => {
    const obj = cookies[Constants.CLUB_STORAGE_NAME] || {};
    setCookieStorage({
      ...obj,
      orgUnitId,
      uIProjectName,
      returnUrl,
      backToSystemLabel
    });
  };

  const setCookieStorage = (newObject) => {
    const expires = new Date();
    expires.setMinutes(expires.getMinutes() + 15);
    setCookie(Constants.CLUB_STORAGE_NAME, {...newObject}, {...Constants.COOKIE_OPTIONS, expires});
  };

  const getPersistentStorage = () => {
    const obj = cookies[Constants.CLUB_STORAGE_NAME];
    if (!obj) {
      const newObj = getDefaultCookieObject();
      setCookieStorage(newObj);
      return newObj;
    } else {
      setCookieStorage(obj);
      return obj;
    }
  };

  const resetClubExpiration = () => {
    const obj = getPersistentStorage();
    setCookieStorage(obj);
  };

  const resetPersistentStorage = () => {
    setCookieStorage({...getDefaultCookieObject()})
  };

  return {
    cookies,
    getPersistentStorage,
    resetClubExpiration,
    setPersistentStorage,
    resetPersistentStorage
  };
};

export default useClubPersistentStorage;